export default {
  DEFAULT_LANGUAGE: 'en',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAEIsBU4a3EIjHdhRSbqW6jtqWoV6gqTBM',
  GOOGLE_PLAY_LINK: 'https://play.google.com/store/apps/details?id=biz.atm.app',
  APP_STORE_LINK: 'https://apps.apple.com/pl/app/atm-biz/id6447573925',
};
